// =============================================================================
// DATA MODELER EDGES - Export all custom edge types
// =============================================================================

export { RelationEdge } from './RelationEdge';

import { RelationEdge } from './RelationEdge';

export const edgeTypes = {
  relationEdge: RelationEdge,
};
